module.exports = __webpack_public_path__ + "img/Smart book.7f748d95.png";